module.exports = __webpack_public_path__ + "static/img/satyamev-jayate.ea25557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/satyamev-jayate.png
// module id = /WaH
// module chunks = 1